import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { InstructorBenefits } from './InstructorBenefits';
export function TestimonialsStrip() {
  if (testimonials.length === 0) return <InstructorBenefits data-id="element-317" data-mp="3ss4up5tjb1hk" />;
  return <section className="py-12 bg-[#F3F7FA] border-y border-slate-200" data-id="element-318" data-mp="3nz21wzwkzw2f">
      <div className="max-w-7xl mx-auto px-4" data-id="element-319" data-mp="5lm0nhy9ryth">
        <div className="text-center mb-7" data-id="element-320" data-mp="5kawvi4tqr2d">
          <h2 className="text-[#0B2545] font-bold tracking-widest uppercase text-sm" data-id="element-321" data-mp="5nf992sg0t44">
            What Nursing Instructors Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-322" data-mp="figuhnjllb1f">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-[#0B2545]/5 flex flex-col" data-id="element-323" data-mp="al8glz5hft5z" data-mpi={index}>
              <div className="flex gap-1 text-amber-500 mb-4" aria-label="5 out of 5 stars" data-id="element-324" data-mp="gby94osool55">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-325" data-mp="q55mavto15fs" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-326" data-mp="v2xi40xflbp9">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-4 border-t border-slate-200" data-id="element-327" data-mp="14451lcvag7za">
                <div className="font-bold text-[#0B2545] text-sm" data-id="element-328" data-mp="141sjmzpj5xm8">{testimonial.name}</div>
                {testimonial.role && <div className="text-xs text-[#025B57] font-semibold mt-0.5" data-id="element-329" data-mp="35vi7o58zslwx">{testimonial.role}</div>}
                <div className="flex items-center gap-1.5 text-xs text-slate-500 mt-1.5" data-id="element-330" data-mp="3atjqcp2iaj7v">
                  <img src={`https://flagcdn.com/${testimonial.countryCode}.svg`} alt="" aria-hidden="true" className="w-[18px] h-[13px] rounded-[2px] object-cover shrink-0 ring-1 ring-black/5" data-id="element-331" data-mp="hz2yngimlu8j" />
                  {testimonial.country}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}